import { changeTab } from './actions/ui';
import { changeImportPage, changeImportRequestPage } from './actions/query';
import { getActiveTab } from './selectors/ui';
import { getImportPage, getImportRequestPage } from './selectors/query';

const queryParams = {
  tab: {
    action: value => value ? changeTab(value) : { type: null },
    selector: state => getActiveTab(state)
  },
  importPage: {
    action: changeImportPage,
    defaultValue: 1,
    selector: state => getImportPage(state),
    stringToValue: value => Number(value) || 1
  },
  importRequestPage: {
    action: changeImportRequestPage,
    defaultValue: 1,
    selector: state => getImportRequestPage(state),
    stringToValue: value => Number(value) || 1
  }
};

export default queryParams;
